import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=38e4630c&"
import script from "./LoginView.vue?vue&type=script&lang=js&"
export * from "./LoginView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports